// 834px matches $mobile in @weareopenr/component-library/build/theme.scss, and the md breakpoint
// the removed MUI theme declared. SCSS tokens are not readable from TypeScript, so the value is
// duplicated here deliberately.
export const TABLET_MIN_WIDTH = 834;

export const TABLET_UP = `(min-width: ${TABLET_MIN_WIDTH}px)`;
